import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-458a41b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "remark" }

import { computed, nextTick, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'

import Editor from './Editor.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    height: {}
  },
  emits: ["update:height"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const slidesStore = useSlidesStore()
const { currentSlide } = storeToRefs(slidesStore)

const editorRef = ref<InstanceType<typeof Editor>>()
watch(() => currentSlide.value.id, () => {
  nextTick(() => {
    editorRef.value!.updateTextContent()
  })
}, {
  immediate: true,
})

const remark = computed(() => currentSlide.value?.remark || '')

const handleInput = (content: string) => {
  slidesStore.updateSlide({ remark: content })
}

const resize = (e: MouseEvent) => {
  let isMouseDown = true
  const startPageY = e.pageY
  const originHeight = props.height

  document.onmousemove = e => {
    if (!isMouseDown) return

    const currentPageY = e.pageY

    const moveY = currentPageY - startPageY
    let newHeight = -moveY + originHeight

    if (newHeight < 40) newHeight = 40
    if (newHeight > 360) newHeight = 360

    emit('update:height', newHeight)
  }

  document.onmouseup = () => {
    isMouseDown = false
    document.onmousemove = null
    document.onmouseup = null
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "resize-handler",
      onMousedown: _cache[0] || (_cache[0] = $event => resize($event))
    }, null, 32),
    _createVNode(Editor, {
      value: remark.value,
      ref_key: "editorRef",
      ref: editorRef,
      onUpdate: _cache[1] || (_cache[1] = value => handleInput(value))
    }, null, 8, ["value"])
  ]))
}
}

})